import 'react';
import { css } from 'styled-components';
import styledTheming from '../node_modules/styled-theming/index.js';
import '../App.css.js';
import { fontEuclidBold, fontEuclidMedium, fontEuclidRegular, fontRobotoBold, fontRobotoMedium, fontRobotoRegular, fontStolzlBold, fontStolzlMedium, fontStolzlRegular, fontEuclidLight, fontEuclidSemibold, fontRobotoLight, fontStolzlLight, fontSizeTextTitle, fontSizeTextSubtitle, fontSizeTextTitleCaption, fontSizeTextCaption, fontSizeTextDefault, fontSizeTextTitleMobile, fontSizeTextSubtitleMobile, fontSizeTextTitleCaptionMobile, fontSizeTextCaptionMobile, fontSizeTextDefaultMobile } from './constants/font-constants.js';
var textColorText = styledTheming.variants("layout", "color", {
  green: {
    light: css(["color:var(--green);"]),
    dark: css(["color:var(--green);"])
  },
  red: {
    light: css(["color:var(--red-300);"]),
    dark: css(["color:var(--red-300);"])
  },
  azure: {
    light: css(["color:var(--azure);"]),
    dark: css(["color:var(--azure);"])
  },
  default: {
    light: css(["color:var(--light-gray-9);"]),
    dark: css(["color:var(--white);"])
  },
  "grey-1": {
    light: css(["color:var(--light-gray-1);"]),
    dark: css(["color:var(--dark-gray-1);"])
  },
  "grey-2": {
    light: css(["color:var(--light-gray-2);"]),
    dark: css(["color:var(--dark-gray-2);"])
  }
});
var textColorTextHover = styledTheming.variants("layout", "color", {
  green: {
    light: css(["color:var(--green-hover);"]),
    dark: css(["color:var(--green-hover);"])
  },
  red: {
    light: css(["color:var(--red-hover);"]),
    dark: css(["color:var(--red-hover);"])
  },
  azure: {
    light: css(["color:var(--azure-hover);"]),
    dark: css(["color:var(--azure-hover);"])
  },
  default: {
    light: css(["color:var(--light-gray-1);"]),
    dark: css(["color:var(--dark-gray-1);"])
  },
  "grey-1": {
    light: css(["color:var(--light-gray-9);"]),
    dark: css(["color:var(--white);"])
  },
  "grey-2": {
    light: css(["color:var(--light-gray-1);"]),
    dark: css(["color:var(--dark-gray-1);"])
  }
});
var fontFamilyTextUnsetEuclid = styledTheming.variants("layout", "type", {
  title: {
    light: css(["", ""], fontEuclidBold),
    dark: css(["", ""], fontEuclidBold)
  },
  subtitle: {
    light: css(["", ""], fontEuclidBold),
    dark: css(["", ""], fontEuclidBold)
  },
  titleCaption: {
    light: css(["", ""], fontEuclidMedium),
    dark: css(["", ""], fontEuclidMedium)
  },
  caption: {
    light: css(["", ""], fontEuclidRegular),
    dark: css(["", ""], fontEuclidRegular)
  },
  default: {
    light: css(["", ""], fontEuclidRegular),
    dark: css(["", ""], fontEuclidRegular)
  }
});
var fontFamilyTextUnsetRoboto = styledTheming.variants("layout", "type", {
  title: {
    light: css(["", ""], fontRobotoBold),
    dark: css(["", ""], fontRobotoBold)
  },
  subtitle: {
    light: css(["", ""], fontRobotoBold),
    dark: css(["", ""], fontRobotoBold)
  },
  titleCaption: {
    light: css(["", ""], fontRobotoMedium),
    dark: css(["", ""], fontRobotoMedium)
  },
  caption: {
    light: css(["", ""], fontRobotoRegular),
    dark: css(["", ""], fontRobotoRegular)
  },
  default: {
    light: css(["", ""], fontRobotoBold),
    dark: css(["", ""], fontRobotoBold)
  }
});
var fontFamilyTextUnsetStolzl = styledTheming.variants("layout", "type", {
  title: {
    light: css(["", ""], fontStolzlBold),
    dark: css(["", ""], fontStolzlBold)
  },
  subtitle: {
    light: css(["", ""], fontStolzlBold),
    dark: css(["", ""], fontStolzlBold)
  },
  titleCaption: {
    light: css(["", ""], fontStolzlMedium),
    dark: css(["", ""], fontStolzlMedium)
  },
  caption: {
    light: css(["", ""], fontStolzlRegular),
    dark: css(["", ""], fontStolzlRegular)
  },
  default: {
    light: css(["", ""], fontStolzlBold),
    dark: css(["", ""], fontStolzlBold)
  }
});
var fontFamilyTextEuclid = styledTheming.variants("layout", "fontWeight", {
  light: {
    light: css(["", ""], fontEuclidLight),
    dark: css(["", ""], fontEuclidLight)
  },
  regular: {
    light: css(["", ""], fontEuclidRegular),
    dark: css(["", ""], fontEuclidRegular)
  },
  medium: {
    light: css(["", ""], fontEuclidMedium),
    dark: css(["", ""], fontEuclidMedium)
  },
  semibold: {
    light: css(["", ""], fontEuclidSemibold),
    dark: css(["", ""], fontEuclidSemibold)
  },
  bold: {
    light: css(["", ""], fontEuclidBold),
    dark: css(["", ""], fontEuclidBold)
  },
  unset: {
    light: css(["", ""], fontFamilyTextUnsetEuclid),
    dark: css(["", ""], fontFamilyTextUnsetEuclid)
  }
});
var fontFamilyTextRoboto = styledTheming.variants("layout", "fontWeight", {
  light: {
    light: css(["", ""], fontRobotoLight),
    dark: css(["", ""], fontRobotoLight)
  },
  regular: {
    light: css(["", ""], fontRobotoRegular),
    dark: css(["", ""], fontRobotoRegular)
  },
  medium: {
    light: css(["", ""], fontRobotoMedium),
    dark: css(["", ""], fontRobotoMedium)
  },
  bold: {
    light: css(["", ""], fontRobotoBold),
    dark: css(["", ""], fontRobotoBold)
  },
  unset: {
    light: css(["", ""], fontFamilyTextUnsetRoboto),
    dark: css(["", ""], fontFamilyTextUnsetRoboto)
  }
});
var fontFamilyTextStolzl = styledTheming.variants("layout", "fontWeight", {
  light: {
    light: css(["", ""], fontStolzlLight),
    dark: css(["", ""], fontStolzlLight)
  },
  regular: {
    light: css(["", ""], fontStolzlRegular),
    dark: css(["", ""], fontStolzlRegular)
  },
  medium: {
    light: css(["", ""], fontStolzlMedium),
    dark: css(["", ""], fontStolzlMedium)
  },
  bold: {
    light: css(["", ""], fontStolzlBold),
    dark: css(["", ""], fontStolzlBold)
  },
  unset: {
    light: css(["", ""], fontFamilyTextUnsetStolzl),
    dark: css(["", ""], fontFamilyTextUnsetStolzl)
  }
});
styledTheming.variants("layout", "fontFamily", {
  euclid: {
    light: css(["", ""], fontFamilyTextEuclid),
    dark: css(["", ""], fontFamilyTextEuclid)
  },
  stolzl: {
    light: css(["", ""], fontFamilyTextStolzl),
    dark: css(["", ""], fontFamilyTextStolzl)
  },
  roboto: {
    light: css(["", ""], fontFamilyTextRoboto),
    dark: css(["", ""], fontFamilyTextRoboto)
  }
});
styledTheming.variants("layout", "type", {
  title: {
    light: css(["", ""], fontSizeTextTitle),
    dark: css(["", ""], fontSizeTextTitle)
  },
  subtitle: {
    light: css(["", ""], fontSizeTextSubtitle),
    dark: css(["", ""], fontSizeTextSubtitle)
  },
  titleCaption: {
    light: css(["", ""], fontSizeTextTitleCaption),
    dark: css(["", ""], fontSizeTextTitleCaption)
  },
  caption: {
    light: css(["", ""], fontSizeTextCaption),
    dark: css(["", ""], fontSizeTextCaption)
  },
  default: {
    light: css(["", ""], fontSizeTextDefault),
    dark: css(["", ""], fontSizeTextDefault)
  }
});
styledTheming.variants("layout", "type", {
  title: {
    light: css(["", ""], fontSizeTextTitleMobile),
    dark: css(["", ""], fontSizeTextTitleMobile)
  },
  subtitle: {
    light: css(["", ""], fontSizeTextSubtitleMobile),
    dark: css(["", ""], fontSizeTextSubtitleMobile)
  },
  titleCaption: {
    light: css(["", ""], fontSizeTextTitleCaptionMobile),
    dark: css(["", ""], fontSizeTextTitleCaptionMobile)
  },
  caption: {
    light: css(["", ""], fontSizeTextCaptionMobile),
    dark: css(["", ""], fontSizeTextCaptionMobile)
  },
  default: {
    light: css(["", ""], fontSizeTextDefaultMobile),
    dark: css(["", ""], fontSizeTextDefaultMobile)
  }
});
export { fontFamilyTextEuclid, fontFamilyTextRoboto, fontFamilyTextStolzl, fontFamilyTextUnsetEuclid, fontFamilyTextUnsetRoboto, fontFamilyTextUnsetStolzl, textColorText, textColorTextHover };